/********************************************************************
* トップページ　スライダー
**********************************************************************/
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

const topSlider = () => {
    const target = document.querySelector('.js_topSlider');
    if (!target) return;

    const swiper = new Swiper(target, {
        modules: [Navigation, Pagination, Autoplay],
        speed: 700,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 'auto',
                centeredSlides: true,
            },
            992: {
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 66,
            }
        }
    });
}

export default topSlider;
